import { createFileRoute, Outlet } from '@tanstack/react-router';

import { AppLayout } from '@/layouts/app-layout';
import { requireAuthenticated } from '@/lib/route-guards';

export const Route = createFileRoute('/_authenticated')({
  beforeLoad: ({ location }) => {
    requireAuthenticated(location.href);
  },
  component: AuthenticatedLayout,
});

function AuthenticatedLayout() {
  return (
    <AppLayout>
      <Outlet />
    </AppLayout>
  );
}
